import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class WebChannelCmpSection
*  Настройки cookie-согласия (CMP)<br>
*/
export class WebChannelCmpSection extends ActiveModel {

  /**
  * enabled
  * Показывать ли баннер согласия на витрине<br>  */
  @ActiveField(false)
  enabled: boolean = false


  /**
  * analyticsCookiesRequireConsent
  * Требуется ли согласие на аналитические cookies («необходимые» — всегда без согласия)<br>  */
  @ActiveField(false)
  analyticsCookiesRequireConsent: boolean = false


  /**
  * marketingCookiesRequireConsent
  * Требуется ли согласие на маркетинговые cookies<br>  */
  @ActiveField(false)
  marketingCookiesRequireConsent: boolean = false


/**
  * privacyPolicyUrl
  * Ссылка на политику конфиденциальности<br>
  */
  @ActiveField(null)
  privacyPolicyUrl: null | string = null


/**
  * bannerText
  * Текст баннера согласия<br>
  */
  @ActiveField(null)
  bannerText: null | string = null


  /**
  * consentTtlDays
  * Срок жизни решения пользователя (в днях)<br>  */
  @ActiveField(0)
  consentTtlDays: number = 0
}
